import * as angular from "angular"
import { defineComponent, handleApiError, IOmniaShell, isAdmin, ITypedStock, shell, StockType } from "../omnia"
import { IMmExport, IStocksService } from "../types"
import { getStockActivity } from "./activity"
import { StockEditCmd } from "./editCmd"
import { TypedStockEditCtrl } from "./editTypedStock"


export class StockEditCtrl extends shell.Component {

    static create(): ng.IDirective {

        return defineComponent(StockEditCtrl, "app/stocks/edit/edit.html");

    };


    newStock: boolean;
    stock: ITypedStock;
    stockType: StockType;
    private _duplicate: boolean;

    private _exports: IMmExport[];

    private editor: TypedStockEditCtrl;

    static $inject = ["$scope", "OmniaStocksService", "OmniaShell"];

    constructor(
        $scope: ng.IScope,
        public stocks: IStocksService,
        private shell: IOmniaShell,
        public readonly readOnly = shell.isReadOnly(p => p.stocks) || (shell.config.features.stocks.v2 && (!isAdmin(shell)))) {

        super($scope)

    }

    protected setup() {

        var cmd: StockEditCmd = this.execArguments;

        this.stock = null;
        this.stockType = null;

        if (cmd) {

            var stock = cmd.stock;

            this.newStock = !stock;

            if (stock) {
                stock = angular.extend({}, stock);
            }

            this.stock = stock;
            this.stockType = cmd.stockType;
            this._duplicate = cmd.duplicate && !!stock;

        }

        this.setTitle()

        this.setActivity(getStockActivity(this.newStock, this.stock || {
            YearId: this.stocks.yearId
        }, this.stockType))

    }

    get exports(): IMmExport[] {

        if (!this._exports) {

            let exports = this.stocks.getManureExports();

            if (exports && this.stock && this.stock.ManureStockId) {
                exports = exports.filter(e => e.ManureStockId === this.stock.ManureStockId);
                if (exports.length) {
                    this._exports = exports;
                }
            }
        }

        return this._exports;
    }

    private setTitle() {

        const msgCreateNewStock = "Create a new stock"
        const msgEditStock = "Edit a stock"
        const msgDuplicateStock = "Duplicate a stock"

        this._title = (this._duplicate ? msgDuplicateStock : (this.stock ? msgEditStock : msgCreateNewStock));
        this._icon = (this._duplicate ? "icon-duplicate" : "fas fa-pen");

    }

    public setCurrentEditor(editor: TypedStockEditCtrl) {
        this.editor = editor;
    }

    isSeedsStock(): boolean {
        return (this.stockType == StockType.Seed);
    }

    isFertiliserStock(): boolean {
        return (this.stockType == StockType.Fertiliser);
    }

    isManureStock(): boolean {
        return (this.stockType == StockType.Manure);
    }

    get duplicate(): boolean {
        return this._duplicate;
    }

    set duplicate(value: boolean) {
        this._duplicate = value;
        this.setTitle();
    }

    canDeleteStock(): boolean {
        return (!this.readOnly) && this.editor && (!this.editor.isUsedInPlans()) && (!this._duplicate) && (!this.newStock) && (!this.exports || !this.exports.length);
    }

    showDeleteStock() {

        const title = "Delete this stock"
        const msg = "<p>Click 'Delete' to delete this stock.</p><p>Please note that this operation is irreversible.</p>"

        shell.showDeleteCancel(this.shell, msg, title).then(r => {
            if (r) {
                this.deleteStock();
            }
        });

    }

    deleteStock() {

        this.stocks.deleteStock(this.stock).then(() => this.cancel());
    }


    get showValidationErrors(): boolean {
        return this.editor && this.editor.showValidationErrors;
    }

    canCommit(): boolean {
        return (!this.readOnly) && this.editor && this.editor.canCommit();
    }

    commit() {

        if (!this.canCommit()) {
            this.editor.showValidationErrors = true;
            return;
        }

        this.editor.showValidationErrors = false;

        this.editor.commit()
            .then(() => this.cancel())
            .catch(r => handleApiError(this.shell, r))

    }
}
